interface LayoutDownloadProps {
  children: React.ReactNode;
  className?: string;
}

export default function LayoutDownload({ children, className }: LayoutDownloadProps) {
  return (
    <div className='flex flex-col w-full min-h-screen'>
      <main className={`flex-1 ${className}`}>{children}</main>
    </div>
  );
}
